import { INTEGRATION_CONSTS, OpinewRoutes, Routes } from './helpers/consts';

import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import { getShopId } from '@/utils/vuex';

window.OPW_API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
window.OPW_CHECKER_ENDPOINT = process.env.VUE_APP_CHECKER_ENDPOINT;
window.OPW_DASHBOARD_VERSION = process.env.APP_VERSION;

const isProd = process.env.NODE_ENV === 'production';

const { hash, search } = window.location;
const token = new URLSearchParams(hash.slice(1) || '').get('token') || storage.getItem('OPW_TOKEN');
const welcomeStep = new URLSearchParams(window.location.search).get('welcome_screen');

storage.setItem('OPW_TOKEN', token);

// TODO: handle reset?
// if (token && token !== localToken) {
//   sessionStorage.clear('vuex');
// }

const omitAuthScreen =
  token &&
  // token === localToken &&
  search.includes('embedded=1') &&
  !search.includes('subscription_activated');

const sourceId = isProd ? 'Tz0r8pZpO58CiPrGJyEcXPASvHrpNVtE' : '2h2Q4HmV8ENNxz7wJ9qprt7XuXB1x2wi';

window.analytics._writeKey = sourceId;
window.analytics.load(sourceId);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

// style
import './styles/global.scss';

// Plugins
import './plugins';
import vuetify from './plugins/vuetify';
import VueLodash from 'vue-lodash';
import { debounce } from 'lodash-es';
import Hotjar from 'vue-hotjar';
import { sync } from 'vuex-router-sync';

// Application imports
import App from './App';
import i18n from '@/i18n';
import router from '@/router';
import store from '@/store';

import OpinewBridge from '@/plugins/app-bridge';
import { shopifySections } from '@/router/paths';
import { setVitalsLogger } from '@/helpers/web-vitals';
import { storage } from '@/utils/storage';
import FirstDataFetcher from '@/helpers/firstDataFetcher';

const polarisMenu = shopifySections.map(el => ({
  label: i18n.t('Drawer.' + el.name),
  destination: '/dashboard' + el.path.replace(/:[\w\-_\\()+]+\??\/?/g, ''),
}));

let opwBridge = {};

if (token) {
  const shopId = getShopId(token);
  store.commit('auth/setAuth', { token, shopId });
  const preloadHash = store.getters.isAccountInfoLoading === false ? '' : '#loading=true';

  if (preloadHash) {
    FirstDataFetcher(store);
  } else {
    opwBridge = window.opwBridge = new OpinewBridge(polarisMenu);
    opwBridge.init();
  }
  if (window.location.pathname.includes('/auth') && omitAuthScreen) {
    const route = welcomeStep ? `/welcome/${welcomeStep}` : Routes.overview;

    history.replaceState({}, '', '/dashboard' + route + search + preloadHash);
  }
} else {
  history.replaceState({}, '', '/dashboard' + Routes.auth + search);
}

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  release: process.env.APP_VERSION,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [
        'localhost',
        process.env.VUE_APP_API_ENDPOINT.replace(/^https?:\/\//, ''),
        /^\//,
      ],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  logErrors: true,
  attachProps: true,
  attachStacktrace: true,
  trackComponents: true,
  tracesSampleRate: 1.0,
});
setVitalsLogger();

// Sync store with router
sync(store, router);

Vue.config.productionTip = false;
Vue.config.devtools = !isProd;

const hideMenu = !!opwBridge.navigationMenu || window.location.hash.includes('loading=true');

/* eslint-disable no-new */
/* eslint-disable vue/require-name-property */
const vue = new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h =>
    h(App, {
      props: { hideMenu },
    }),
});

Vue.use(VueLodash, { name: 'custom', lodash: { debounce } });

Vue.use(Hotjar, {
  id: INTEGRATION_CONSTS.HOTJAR_ID, // Hotjar Site ID
  isProduction: isProd,
  snippetVersion: INTEGRATION_CONSTS.HOTJAR_SNIPPET_VERSION,
});
Vue.use(OpinewRoutes);

vue.$mount('#app');
